export default __webpack_public_path__ + "static/RoobertPRO-Bold-f3f5f4313a43838c764749c2f8f3ebde.otf";